// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendor" + "." + "c383fda44b396ed38101" + ".js";
};